// Single place that decides which dashboard/UI experience each account type
// gets. redux `signin.type` always holds the real orgType from the DB
// ('individual' | 'business' | 'nonprofit' | 'company'); components should
// branch on the role returned here, not on the raw type.
//
// To ship a dedicated business dashboard:
//   1. Add 'business' to DashboardRole.
//   2. Change `business: 'individual'` to `business: 'business'` below.
//   3. Add 'business' branches where components check the role (dashboard.tsx,
//      Sidebar, navbar, TopHeader, ...) and to ProtectedRoute allowedTypes in
//      App.tsx — every other place keeps working unchanged.

export type AccountType = 'individual' | 'business' | 'nonprofit' | 'company';
export type DashboardRole = 'individual' | 'nonprofit';

const DASHBOARD_ROLE_BY_ACCOUNT: Record<string, DashboardRole> = {
  individual: 'individual',
  business: 'individual', // businesses use the donor dashboard for now
  nonprofit: 'nonprofit'
};

// Returns the UI role for an account type. Unknown/legacy types (e.g.
// 'company') pass through unchanged; logged-out users return undefined.
export const getDashboardRole = (type?: string): DashboardRole | string | undefined =>
  type ? DASHBOARD_ROLE_BY_ACCOUNT[type] || type : undefined;

export const isDonorRole = (type?: string) => getDashboardRole(type) === 'individual';

export const isBusinessAccount = (type?: string) => type === 'business';
